/**
 * @prettier
 */

const TextInput = ({
    label,
    isRequired,
    placeholder,
    error,
    config,
    onChange,
    defaultValue,
    inputProps = {},
    reserveErrorSpace = false,
}) => {
    const errorMessage = error ? (
        <span role="alert" className="error-text">
            {error}
        </span>
    ) : null;

    return (
        <div style={{ position: "relative" }}>
            <input
                id={config.id}
                type="text"
                placeholder={placeholder}
                className={`text-input ${error ? "error" : ""}`}
                onChange={onChange}
                aria-invalid={error ? true : false}
                aria-required={isRequired}
                aria-describedby={label}
                defaultValue={defaultValue}
                {...inputProps}
            />
            <label
                htmlFor={config.id}
                id={config.id}
                className={`text-input-label ${isRequired ? "required" : ""}`}
                style={{ position: "absolute", color: error ? "red" : "#000" }}
            >
                {label}
            </label>
            {reserveErrorSpace ? (
                <div className="field-error-slot" aria-live="polite">
                    {errorMessage}
                </div>
            ) : (
                errorMessage
            )}
        </div>
    );
};
export default TextInput;
